import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';
import { WarehouseGrid } from './components/WarehouseGrid';
import { WarehouseDetails } from './components/WarehouseDetails';
import { QuotesPage } from './pages/QuotesPage';
import { QuotesPageV2 } from './pages/QuotesPageV2';
import { QuotesPageV3 } from './pages/QuotesPageV3';
import { QuotesPageV4 } from './pages/QuotesPageV4';
import { DesignPage } from './pages/DesignPage';
import { HomePageAlternative } from './pages/HomePageAlternative';
import { HomePageAlternative2 } from './pages/HomePageAlternative2';
import { DashboardPage } from './pages/DashboardPage';
import { DashboardPageAlternative } from './pages/DashboardPageAlternative';
import { OrdersPage } from './pages/OrdersPage';
import { NewQuotePage } from './pages/NewQuotePage';
import { ViewQuotePage } from './components/quotes/ViewQuotePage';
import { DealersPage } from './pages/DealersPage';
import { DealerDetailsPage } from './pages/DealerDetailsPage';
import { AdminPage } from './pages/AdminPage';
import { CustomerSupportPage } from './pages/CustomerSupportPage';
import { ClaimsReportsPage } from './pages/ClaimsReportsPage';
import { BusinessIntelligencePage } from './pages/BusinessIntelligencePage';
import { BusinessIntelligencePageV2 } from './pages/BusinessIntelligencePageV2';
import { SystemSettingsPage } from './pages/SystemSettingsPage';
import { FairProvider } from './contexts/FairContext';
import { ICADPage } from './pages/ICADPage';
import { ImpersonationBar } from './components/ImpersonationBar';
// Wrapper component to handle navigation
function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [activePage, setActivePage] = useState('home');
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [isNewQuote, setIsNewQuote] = useState(false);
  const [isEditingQuote, setIsEditingQuote] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // Update activePage based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path === '/') setActivePage('home');else if (path === '/home2') setActivePage('home');else if (path === '/dashboard') setActivePage('dashboard');else if (path === '/design') setActivePage('design');else if (path === '/quotes') setActivePage('quotes');else if (path === '/quotes-v2') {
      setActivePage('quotes-v2');
      // Auto-collapse main sidebar in Quotes V2 module for max workspace
      setSidebarCollapsed(true);
    } else if (path === '/quotes-v3') {
      setActivePage('quotes-v3');
      setSidebarCollapsed(true);
    } else if (path === '/quotes-v4') {
      setActivePage('quotes-v4');
      setSidebarCollapsed(true);
    } else if (path === '/order') setActivePage('order');else if (path === '/dealers') setActivePage('dealers');else if (path.includes('/dealers/')) setActivePage('dealers');else if (path === '/warehouses') setActivePage('warehouses');else if (path === '/support') setActivePage('support');else if (path.includes('/support/')) setActivePage('support');else if (path === '/admin') setActivePage('admin');else if (path === '/business-intelligence') setActivePage('business-intelligence');else if (path === '/business-intelligence-v2') setActivePage('business-intelligence-v2');else if (path === '/icad') setActivePage('icad');else if (path === '/subscription') setActivePage('subscription');else if (path === '/settings') setActivePage('settings');
  }, [location]);
  const handleViewDetails = warehouse => {
    setSelectedWarehouse(warehouse);
  };
  const handleBackToList = () => {
    setSelectedWarehouse(null);
  };
  const handleNavigate = page => {
    setActivePage(page);
    setSelectedWarehouse(null);
    setSelectedQuote(null);
    setIsNewQuote(false);
    setIsEditingQuote(false);
    // Map page identifier to actual route
    switch (page) {
      case 'home':
        navigate('/');
        break;
      case 'dashboard':
        navigate('/dashboard');
        break;
      case 'design':
        navigate('/design');
        break;
      case 'quotes':
        navigate('/quotes');
        break;
      case 'quotes-v2':
        navigate('/quotes-v2');
        break;
      case 'quotes-v3':
        navigate('/quotes-v3');
        break;
      case 'quotes-v4':
        navigate('/quotes-v4');
        break;
      case 'order':
        navigate('/order');
        break;
      case 'dealers':
        navigate('/dealers');
        break;
      case 'warehouses':
        navigate('/warehouses');
        break;
      case 'support':
        navigate('/support');
        break;
      case 'admin':
        navigate('/admin');
        break;
      case 'business-intelligence':
        navigate('/business-intelligence');
        break;
      case 'business-intelligence-v2':
        navigate('/business-intelligence-v2');
        break;
      case 'icad':
        navigate('/icad');
        break;
      case 'subscription':
        navigate('/subscription');
        break;
      case 'settings':
        navigate('/settings');
        break;
      default:
        navigate('/');
    }
  };
  const handleNewQuote = () => {
    setIsNewQuote(true);
    setIsEditingQuote(false);
  };
  const handleViewQuote = quote => {
    setSelectedQuote(quote);
    setIsNewQuote(false);
    setIsEditingQuote(false);
  };
  const handleBackToQuotes = () => {
    setSelectedQuote(null);
    setIsNewQuote(false);
    setIsEditingQuote(false);
  };
  const handleEditQuote = () => {
    // Activar el modo de edición para la cotización seleccionada
    setIsEditingQuote(true);
    setIsNewQuote(false);
  };
  // Handle toggling the sidebar state
  const handleToggleSidebar = (forceCollapse = false) => {
    if (forceCollapse) {
      setSidebarCollapsed(true);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };
  return <div className="flex flex-col w-full h-screen overflow-hidden bg-gray-100" data-id="element-0" data-mp="1wtsmcpsaqa2t">
      <ImpersonationBar data-id="element-1" data-mp="2atbkqqvb271x" />
      <div className="flex flex-1 overflow-hidden" data-id="element-2" data-mp="2attos9o7lpke">
        {activePage !== 'icad' && <Sidebar onNavigate={handleNavigate} activePage={activePage} collapsed={sidebarCollapsed} onToggleSidebar={handleToggleSidebar} data-id="element-3" data-mp="25s4aml5owvs3" />}
        <div className="flex-1 flex flex-col overflow-auto transition-all duration-300" data-id="element-4" data-mp="2kobufkd6rv6u">
          {activePage === 'warehouses' && !selectedWarehouse && <Header data-id="element-5" data-mp="2tizzb9eunav4" />}
          <main className="flex-1 bg-gray-100" data-id="element-6" data-mp="2thgkln8ud7vg">
            <Routes data-id="element-7" data-mp="2ph4ys74qt1ie">
              <Route path="/" element={<HomePageAlternative onNavigate={handleNavigate} data-id="element-9" data-mp="2pig4ichr0jc5" />} data-id="element-8" data-mp="2pgmxux74xz45" />
              <Route path="/home2" element={<HomePageAlternative2 onNavigate={handleNavigate} data-id="element-11" data-mp="33hpj57qb35e0" />} data-id="element-10" data-mp="33gefr90rvznf" />
              <Route path="/warehouses" element={selectedWarehouse ? <WarehouseDetails {...selectedWarehouse} onBack={handleBackToList} data-id="element-13" data-mp="2yjnyiid8ey0f" /> : <div className="p-6" data-id="element-14" data-mp="3i4y0kqa7k6yf">
                      <WarehouseGrid onViewDetails={handleViewDetails} data-id="element-15" data-mp="3i1sc9d9el93r" />
                    </div>} data-id="element-12" data-mp="2yicxurf326dj" />
              <Route path="/quotes" element={isNewQuote || isEditingQuote ? <NewQuotePage onBack={handleBackToQuotes} isEditing={isEditingQuote} quoteData={isEditingQuote ? selectedQuote : null} data-id="element-17" data-mp="384nkmxwsglfk" /> : selectedQuote ? <ViewQuotePage quoteData={selectedQuote} onBack={handleBackToQuotes} onEdit={handleEditQuote} data-id="element-18" data-mp="3d6cysmfb5f7v" /> : <QuotesPage onNewQuote={handleNewQuote} onViewQuote={handleViewQuote} onToggleSidebar={handleToggleSidebar} data-id="element-19" data-mp="2zbalhe84snl1" />} data-id="element-16" data-mp="3n0dchconnss7" />
              <Route path="/quotes-v2" element={<QuotesPageV2 data-id="element-21" data-mp="2pga7w9n4qfau" />} data-id="element-20" data-mp="2pfhc23ppla7h" />
              <Route path="/quotes-v3" element={<QuotesPageV3 data-id="element-23" data-mp="2udivipr1rbjh" />} data-id="element-22" data-mp="2pd4jyxq8ljgp" />
              <Route path="/quotes-v4" element={<QuotesPageV4 data-id="element-25" data-mp="2ubpkyzdbc767" />} data-id="element-24" data-mp="2uetumc9jrv49" />
              <Route path="/dealers" element={<DealersPage data-id="element-27" data-mp="2geswv5okx3t0" />} data-id="element-26" data-mp="2gdrbo8dun0xk" />
              <Route path="/dealers/:dealerId" element={<DealerDetailsPage data-id="element-29" data-mp="2kg4eanxauiq4" />} data-id="element-28" data-mp="2ggn8ftdynjkf" />
              <Route path="/design" element={<DesignPage data-id="element-31" data-mp="30vdhc1s1wl0w" />} data-id="element-30" data-mp="2kf2zc8d5xc34" />
              <Route path="/dashboard" element={<DashboardPageAlternative data-id="element-33" data-mp="30uly7qfn4fri" />} data-id="element-32" data-mp="30uc882uli8lt" />
              <Route path="/order" element={<OrdersPage data-id="element-35" data-mp="2vxlsxhqm7h1g" />} data-id="element-34" data-mp="2vvr7817irkwb" />
              <Route path="/support" element={<CustomerSupportPage data-id="element-37" data-mp="2qwxsk5ghxnuk" />} data-id="element-36" data-mp="2vu7o82uhavqu" />
              <Route path="/support/claims/reports" element={<ClaimsReportsPage data-id="element-39" data-mp="2ly4o12j6t76j" />} data-id="element-38" data-mp="2qvwj25f4p9ey" />
              <Route path="/admin" element={<AdminPage data-id="element-41" data-mp="2lxuyth5yv41w" />} data-id="element-40" data-mp="2lx32u58gj4b3" />
              <Route path="/business-intelligence" element={<BusinessIntelligencePage data-id="element-43" data-mp="2hxb2gft7w4gt" />} data-id="element-42" data-mp="2hwj4wzg27wnw" />
              <Route path="/business-intelligence-v2" element={<BusinessIntelligencePageV2 data-id="element-45" data-mp="2d4rld8vbmr79" />} data-id="element-44" data-mp="2d5szxnbjpvtq" />
              <Route path="/icad" element={<ICADPage onNavigate={handleNavigate} data-id="element-47" data-mp="2866n3ezmqhlg" />} data-id="element-46" data-mp="2d3ygkdfxabrr" />
              <Route path="/settings" element={<SystemSettingsPage data-id="element-49" data-mp="237v9ct67rmxy" />} data-id="element-48" data-mp="284lu3tsyr6pp" />
              <Route path="*" element={<div className="p-6 flex items-center justify-center h-full" data-id="element-51" data-mp="235in43tfaqf3">
                    <div className="text-center" data-id="element-52" data-mp="1y80nx557jpka">
                      <h2 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-53" data-mp="1u76ujw8zxik0">
                        Page Not Found
                      </h2>
                      <p className="text-gray-600" data-id="element-54" data-mp="9ocw6up8ji7z">
                        The page you are looking for does not exist
                      </p>
                    </div>
                  </div>} data-id="element-50" data-mp="2396g91uyhata" />
            </Routes>
          </main>
        </div>
      </div>
    </div>;
}
export function App() {
  return <Router data-id="element-55" data-mp="nncihvp9zl0z">
      <FairProvider data-id="element-56" data-mp="nnw2rj2eeli6">
        <AppContent data-id="element-57" data-mp="nmb8zvnwr6ld" />
      </FairProvider>
    </Router>;
}